import type { ILoginLocale } from '@/Pages/Onboard/Login/Locale/Login.locale';

const enUS: ILoginLocale = {
  title: 'Login to {brand}',
  email: {
    label: 'Email',
    placeholder: 'example@email.com',
    error: 'Please enter a valid email address',
  },
  password: {
    label: 'Password',
    placeholder: 'Your password',
    error: 'Password is required',
  },
  button: {
    login: 'Login',
    forgotPassword: 'Forgot Password?',
  },
  terms: {
    message1: 'By logging in, you agree to our ',
    message2: '',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
  },
  errors: {
    invalidCredentials: 'Invalid email or password',
    accountLocked: 'Your account has been locked due to multiple failed login attempts',
    accountDisabled: 'Your account has been disabled. Please contact support',
    networkError: 'Network error. Please check your connection and try again',
    twoFactorRequired: 'Two-factor authentication is required',
  },
};
export { enUS };
